import { createFileRoute } from '@tanstack/react-router'

import { Page } from '@/components/layout/page'

import { AccountTable } from '@/features/account/components/account-table'

export const Route = createFileRoute('/_app/settings/user/')({
  component: Component,
})

function Component() {
  return (
    <Page>
      <Page.Breadcrumbs />
      <AccountTable />
    </Page>
  )
}
